import { OkVal } from '@core/model/framework/Result/OkResult';
import { Usecase } from '@core/model/framework/usecase';
import type { ConsentService } from '@core/model/service/consentService';
import { TermsDto } from '@core/service/digital-factory/consent/types/dto/termsDto';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type GetTermsInput = {
  userToken: string;
};
export type GetTermsOutput = Promise<OkVal<TermsDto>>;

@injectable()
export class GetTerms implements Usecase<GetTermsInput, GetTermsOutput> {
  constructor(
    @inject(SERVICE_ID.consentService)
    private readonly consentService: ConsentService
  ) {}

  async execute(cmd: GetTermsInput): GetTermsOutput {
    return this.consentService.getTerms(cmd);
  }
}
